<script lang="ts">
    import Cart_Row from "./Cart_Row.svelte";
    import type { CartProduct, CartType } from "../model";
    import { api, cart } from "../stores";
    import { onMount } from "svelte";
    import { Link } from "svelte-navigator";

    export let type: CartType = "shoppingList";
    export let modelRow: "simple" | "standard" = "simple";
    export let color: string = "black";

    let cartList;
    $: cartList = $cart.list;
    $: cartCount = $cart.count;

    let totalPrice: number = 0;
    let totalFidelity: number = 0;
    let totalDiscount: number = 0;
    let lockRefresh = false;

    onMount(async () => {
        cartList.subscribe(async (list) => {
            await refreshTotalPrice(list);
        });
    });

    async function refreshTotalPrice(list: CartProduct[]) {
        // if (!lockRefresh) {
        lockRefresh = true;
        totalPrice = 0;
        totalFidelity = 0;
        totalDiscount = 0;
        let mirrorTotalPrice = 0;
        let mirrorTotalFidelity = 0;
        let mirrorTotalDiscount = 0;
        for (const p of list) {
            if (p.price && p.quantity) {
                if (p.cartType === type) {
                    mirrorTotalPrice = mirrorTotalPrice + Number(p.price);
                    mirrorTotalPrice = Math.round(mirrorTotalPrice * 100) / 100;
                    let product = await $api.getProduct(p.uid);
                    let discountAmount = 0;

                    if (p.meca == "meca4") {
                        if (product.discountUnit == "€") {
                            discountAmount = Number(product.discountAmount);
                        } else if (product.discountUnit == "%") {
                            discountAmount =
                                (Number(product.discountAmount) *
                                    Number(product.price)) /
                                100;
                        }

                        discountAmount = discountAmount * p.quantity;
                        mirrorTotalFidelity =
                            mirrorTotalFidelity + discountAmount;
                    }
                    if (p.meca == "meca1" || p.meca == "meca2") {
                        if (product.discountUnit == "€") {
                            discountAmount = Number(product.discountAmount);
                        } else if (product.discountUnit == "%") {
                            discountAmount =
                                (Number(product.discountAmount) *
                                    Number(product.price)) /
                                100;
                        }

                        mirrorTotalDiscount += discountAmount * p.quantity;
                    }

                    if (p.meca == "meca3") {
                        let unitPrice = parseFloat(product.price); // unit price
                        let percent = parseFloat(product.discountAmount); // percent discount
                        let unitPriceDiscounted = (percent * unitPrice) / 100; // unit price discount
                        mirrorTotalDiscount += p.nbLot * unitPriceDiscounted;
                    }
                }
            }
        }
        totalPrice = mirrorTotalPrice;
        totalFidelity = mirrorTotalFidelity;
        totalDiscount = mirrorTotalDiscount;
        lockRefresh = false;
        // }
    }
</script>

<div class="cart">
    <div class="left-part">
        <div
            class="cart-header"
            class:row-standard={modelRow === "standard"}
            class:row-simple={modelRow === "simple"}
        >
            <div class="col-product">Produits</div>
            <div class="col-size">Taille</div>
            <div class="col-price">Prix unitaire</div>
            <div class="col-promo">Promotion</div>
            <div class="col-quantity">Quantité</div>
        </div>
        <div class="list-product">
            {#each $cartList as product (product.uid)}
                {#if product.uid && product.cartType === type}
                    <div class="cart-row">
                        <Cart_Row {...product} {color} {modelRow} />
                    </div>
                {/if}
            {/each}
        </div>
    </div>

    <div class="right-part">
        <div class="cart-resume">
            <h1>Récaptilatif</h1>
            <div class="row">
                <div class="total-text txt-{color}">
                    <h3>Total articles</h3>

                    {#if $cartCount > 0 ? $cartCount.toString() : null}
                        <div class="cart-counter">
                            {$cartCount}
                        </div>
                    {/if}
                </div>
                <div class="total-price txt-{color}">
                    <h1>
                        {totalPrice.toFixed(2).replace(".", ",")} <sup>€</sup>
                    </h1>
                </div>
            </div>
            {#if totalFidelity > 0}
            <div class="row">
                <div class="total-tel">
                    <h1>
                        <span class="pre-title">dont</span>
                        {totalFidelity.toFixed(2).replace(".", ",")}
                        <sup>€</sup>
                    </h1>
                    <p>sur la cate de fidelité</p>
                </div>
            </div>
            {/if}
            {#if totalDiscount > 0}
                <div class="row">
                    <div class="total-text txt-{color}">
                        <h3>Total économisés</h3>
                    </div>
                    <div class="total-price txt-{color}">
                        <h1>
                            {totalDiscount.toFixed(2).replace(".", ",")}
                            <sup>€</sup>
                        </h1>
                    </div>
                </div>
            {/if}
            <div class="shopping-list-action">
                <div class="footer-action">
                    <button class="bg-dark-black">
                        Imprimer
                        <span class="icon">
                            <i class="printer" />
                        </span>
                    </button>
                    <button class="bg-dark-black">
                        Passer commande
                        <span class="icon">
                            <i class="fas fa-arrow-right" />
                        </span>
                    </button>
                </div>
            </div>
        </div>

        <div class="action-buttons">
            <Link to="../products">
                <button class="bg-light-white">Continuer ma liste</button>
            </Link>
        </div>
    </div>
</div>

<style lang="scss">
    @import "../styles/variables";

    .cart {
        display: flex;
        flex-direction: row;
        gap: 5px;
        @media (max-width: $mobile-breakpoint) {
            flex-direction: column;
        }
    }

    .shopping-list-action {
        display: flex;
        padding: 0 5px;
        margin: 0.5em 0;
        float: left;
        width: 100%;
        align-items: center;
        .footer-action {
            width: 100%;
            text-align: end;
            button {
                align-items: center;
                height: 40px;
                padding: 0 15px;
                margin: 5px;
                line-height: 38px;
                font-size: 15px;
                border-radius: 10px;
                color: #ffffff;
                border: unset;
                cursor: pointer;
                text-decoration: unset;
                font-style: normal;
                font-weight: 500;
                .icon {
                    width: 20px;
                    height: 20px;
                    float: right;
                    margin-top: 8px;
                    margin-left: 5px;
                }
            }
        }
    }

    .pre-title {
        font-size: 0.9rem;
    }

    .cart-counter {
        background-color: $dark-mauve;
        border-radius: 50%;
        color: white;
        height: 25px;
        width: 25px;
        text-align: center;
    }

    .total-price {
        display: flex;
        flex-direction: row;
        margin-left: auto;
    }

    .left-part {
        width: 80%;
        @media (max-width: $mobile-breakpoint) {
            width: 100%;
        }
    }

    .right-part {
        width: 30%;
        display: flex;
        flex-direction: column;

        @media (max-width: $mobile-breakpoint) {
            width: 100%;
        }
    }

    .action-buttons {
        display: flex;
        flex-direction: column;
        width: 100%;
        padding: 0.5rem 2rem;

        button {
            width: 100%;
            height: 40px;
            border-radius: 10px;
            color: black;
            border: 1px solid black;
            cursor: pointer;
            text-decoration: unset;
            font-style: normal;
            font-weight: 500;
            .icon {
                width: 20px;
                height: 20px;
                float: right;
                margin-top: 8px;
                margin-left: 5px;
            }
        }
    }

    .cart-resume {
        border: 2px solid black;
        padding: 0.5rem;
        border-radius: 10px;
    }

    h1 {
        font-size: 30px;
        line-height: 32px;
        font-weight: bold;
        color: black;
        font-family: "Diagramm Bold";
    }

    h3 {
        font-size: 18px;
        line-height: 28px;
        font-weight: bold;
    }

    // header ----------------------------
    .cart-header {
        border-radius: 12px;
        background-color: $grey-light;
        padding: 1em;
        font-size: 13px;
        line-height: 20px;
        background-color: $beige;

        * {
            color: black;
            font-weight: 900 !important;
            font-family: "Gilmer Bold" !important;
        }

        @media (max-width: $mobile-breakpoint) {
            display: none;
        }
    }

    // body ----------------------------
    .cart-row {
        width: 100%;
        padding: 0;
        margin: 0;
        margin-top: 0.3em;
        border: 1px solid $grey-light;
        border-radius: 12px;
        float: left;
    }

    // footer ----------------------------
    .cart-resume {
        display: flex;
        flex-direction: column;

        .row {
            display: flex;
            padding: 10px 5px;
            align-items: center;

            .total-text {
                padding-left: 5px;
                display: flex;
                margin-right: auto;
                margin-top: auto;
                gap: 5px;
            }

            .total-tel {
                display: flex;
                margin-left: auto;
                text-align: center;
                color: $dark-blue;
                align-items: baseline;
                gap: 3px;
                h1 {
                    font-size: 1.3rem;
                }

                p {
                    font-size: 0.9rem;
                }
            }
        }
    }
</style>
